"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoxStyled = function BoxStyled(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var styles = (0, _core.makeStyles)({
    root: className
  });
  var classes = styles();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.root
  }, children);
};

BoxStyled.propTypes = {
  className: _propTypes.default.object.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
BoxStyled.defaultProps = {
  children: null
};
var _default = BoxStyled;
exports.default = _default;